import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";

const COVER = "https://static.prod-images.emergentagent.com/jobs/2e360db4-79c7-4489-9f27-5d85af163a96/images/b43c371e8463ba141c8605960e0db1a95b47346879a778d3926e2f7807500787.jpeg";

export function EbookBanner() {
  return (
    <Link to="/ebook" className="inverse group flex items-center gap-5 bg-[#2C3413] rounded-2xl p-5 md:p-6 mb-10 hover:brightness-110 transition-all" data-testid="ebook-promo-banner">
      <img src={COVER} alt="From Denied to Approved ebook" className="w-16 md:w-20 rounded-lg shadow-lg shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <BookOpen className="w-3.5 h-3.5 text-[#B9C77F]" />
          <span className="text-[10px] font-semibold tracking-widest uppercase text-[#B9C77F]" style={{ fontFamily: "Inter, sans-serif" }}>The Ebook · $4.99</span>
        </div>
        <p className="font-display text-white text-lg md:text-xl leading-snug">From Denied to Approved — the complete Credit Restoration Roadmap</p>
        <p className="text-white/55 text-xs mt-1 hidden sm:block" style={{ fontFamily: "Inter, sans-serif" }}>The step-by-step system we use with paying clients. Instant download.</p>
      </div>
      <span className="btn-gold !py-2.5 !px-4 !text-[12px] !bg-[#B9C77F] !text-[#23261C] shrink-0 hidden sm:inline-flex">
        Get it <ArrowRight className="w-4 h-4" />
      </span>
    </Link>
  );
}

export function EbookInline() {
  return (
    <Link to="/ebook" className="flex items-center gap-4 bg-white border border-[#4F5D1E]/25 rounded-2xl p-4 mt-10 hover:border-[#4F5D1E]/60 transition-all group" data-testid="ebook-promo-inline">
      <img src={COVER} alt="From Denied to Approved ebook" className="w-14 rounded-md shadow shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-[10px] font-semibold tracking-widest uppercase text-[#4F5D1E] mb-0.5" style={{ fontFamily: "Inter, sans-serif" }}>Want the full roadmap? · $4.99</p>
        <p className="font-display text-[#23261C] text-base leading-snug group-hover:text-[#4F5D1E] transition-colors">From Denied to Approved — the complete Credit Restoration ebook</p>
      </div>
      <ArrowRight className="w-4 h-4 text-[#4F5D1E] shrink-0" />
    </Link>
  );
}
